/* eslint-disable quotes */
/* eslint-disable max-len */
import React, { Component } from 'react';
import Modal from '../common/Modal';
import { Redirect } from 'react-router-dom';

export class AgentTwoStepVerificationModal extends Component {
  state = {
    isModalOpen: true,
    fadeModalOut: false,
    restartVerification: false
  }

  // used for Agent Info Verification
  toggleModal = () => {
    if (this.state.isModalOpen) {
      // sets fadeModalOut flag to true. Common Modal will detect prevProp change and will fade out modal
      // when modal fades out, isModalOpen is set to false and modal is destroyed
      this.props.clearVerificationInfo()
      this.setState({ fadeModalOut: true }, () => {
        setTimeout(() => {
          this.setState({ isModalOpen: false })
        }, 1000)
      })
    } else {
      this.setState({ fadeModalOut: false, isModalOpen: true })
    }
  }

  restartVerification = async () => {
    const { agentID, restartAgentVerificationInfoAction } = this.props;
    
    await restartAgentVerificationInfoAction(agentID);
    
    this.setState({ restartVerification: true })
  }

  render() {
    const { fadeModalOut, isModalOpen, restartVerification } = this.state;
    
    return (
      <div className="AIV__confirmation">
        { restartVerification ? <Redirect to={'/AgentInfoVerification'} /> : "" }
        { isModalOpen &&
          <Modal
              domQuery="body"
              toggleModal={this.toggleModal}
              fadeModalOut={fadeModalOut}
          >
            <div className="AgentTwoStepVerificationModal">
              <div className="AgentTwoStepVerificationModal__title">
                  Two-step Verification
              </div>
              <div className="AgentTwoStepVerificationModal__subtitle">
                  For the additional verification step, please check your email and
                  <br></br>
                  follow the steps in the link provided. 
              </div>
              <div className="AgentTwoStepVerificationModal__body-text">
                  Your account will be locked if the verification process is incomplete. 
              </div>
              <div className="AgentTwoStepVerificationModal__ftr">
                <button 
                    className="AgentTwoStepVerificationModal__restart-link"
                    onClick={ this.restartVerification }
                >
                    Restart verification process
                </button>
                <button className="AgentTwoStepVerificationModal__close" onClick={ this.toggleModal }>
                    OK
                </button>
              </div>
            </div>
          </Modal>
        }
      </div>
    );
  }
}

export default AgentTwoStepVerificationModal;



// WEBPACK FOOTER //
// ./src/features/agent-info-verification/components/AgentTwoStepVerificationModal.js